export function updateWorker(data) {
    let { updateWorkerRequest, updateWorkerError, updateWorkerResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'update_worker',
        this.createBundle('update_worker', { worker: data }, this.POST, updateWorkerRequest, updateWorkerResult, updateWorkerError)
    )
}
